import { Stage } from '@xbcb/shared-types';

export const translationCdnUrls = {
  [Stage.ALPHA]: 'https://d3vdzzpgf7bj45.cloudfront.net',
  [Stage.BETA]: 'https://d2r3t9c3phb1wo.cloudfront.net',
  [Stage.BRAVO]: 'https://d2r3t9c3phb1wo.cloudfront.net', // use beta translations
  [Stage.GAMMA]: 'https://d1k6yuau4xiscx.cloudfront.net',
  [Stage.PROD]: 'https://d3k7d2dfg9edi7.cloudfront.net',
};
